import { AuthFlowError } from '@griply/types';
import { useMutation } from '@tanstack/react-query';
import { revertEmailChange } from 'shared/services/backend-api';

export const useRevertEmailChangeMutation = () =>
  useMutation<string, AuthFlowError, { token: string; password: string }>({
    mutationFn: ({ token, password }) => revertEmailChange(token, password),
  });
